//Table ant design

import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';

import DropdownEditPhone from '../../components/Dropdown/DropdownEditPhone';
import ModalPhoneList from '../../components/Modal/ModalPhoneList';
import { Table } from 'ant-table-extensions';
import { useTranslation } from 'react-i18next';

function PhoneList({ dataPhone, deviceId }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [type, setType] = useState();
  const columns = [
    {
      title: 'ID',
      dataIndex: 'index',
      key: 'index',
      render: ([name, dataPhone, deviceId, index]) => (
        <DropdownEditPhone
          deviceId={deviceId}
          listPhone={dataPhone}
          name={name}
          index={index}
        />
      ),
      width: 200,
    },
    {
      title: t('name').toUpperCase(),
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.phone.charAt(0) - b.phone.charAt(0),
      sortDirections: ['ascend', 'descend'],
      width: 250,
    },
    {
      title: t('phone').toUpperCase(),
      dataIndex: 'phone',
      key: 'phone',
      sorter: (a, b) => a.phone.charAt(0) - b.phone.charAt(0),
      sortDirections: ['ascend', 'descend'],
      width: 250,
    },
  ];

  const data = dataPhone?.map((item, idx) => ({
    index: [item.name, dataPhone, deviceId, idx],
    name: item.name,
    phone: item.phone,
  }));

  const handlePhone = () => {
    setShow(true);
    setType('add-new');
  };

  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <Modal.Title className="btn__edit-title">{t('list-phone')}</Modal.Title>
        <Button variant="primary" onClick={handlePhone}>
          + {t('add-new')}
        </Button>
      </div>
      <Table columns={columns} dataSource={data} scroll={{ x: true }} />
      <ModalPhoneList
        type={type}
        show={show}
        setShow={setShow}
        deviceId={deviceId}
        listPhone={dataPhone}
      />
    </div>
  );
}

export default PhoneList;
